module.exports = __webpack_public_path__ + "img/plus.32f6f8b3.svg";